<div class="error-page-container">
  <div class="error-content">
    <h1 class="error-code">403</h1>
    <h4 class="error-title" translate>errors.forbidden_title</h4>
    <p class="error-description" translate>errors.forbidden_description</p>
    <button pButton type="button" class="p-button-primary" (click)="goToCustomers()" translate>
      buttons.go_to_customers
    </button>
  </div>
</div>
